// extracted by mini-css-extract-plugin
export default {"loader":"loader_loader__5x2cA","rotation":"loader_rotation__++GUj"};